import axios, { AxiosPromise } from 'axios'
import { TerritorioMicroareaQueryInput } from 'graphql/types.generated'

export class AcompanhamentoTerritorio {
  gerarCsvTerritorioMicroarea(input: TerritorioMicroareaQueryInput): AxiosPromise {
    return axios.post('/api/visualizacaoTerritorial/gerarCsvTerritorioMicroarea', input, {
      responseType: 'blob',
    })
  }
}
